var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dui-loading-indicator loading-indicator",class:[ _vm.vm.colorClass, _vm.size ]},[_c('span',{class:_vm.loadingType})])}
var staticRenderFns = []

export { render, staticRenderFns }